import styled from '@emotion/styled';
import { Phone } from '@phosphor-icons/react';
import { Text } from '@updater/ui-uds';
import { CallRailPhone, CallRailComponentType } from 'components/CallRailPhone';
import { Events } from 'services';

// The switch is at the `s` breakpoint (375px): only the narrowest screens get
// the button, everything wider gets "Questions?" over the number. Done in CSS
// so there's no viewport hook or hydration flicker.
const MobileCall = styled.div`
  display: block;

  ${({ theme }) => theme.mediaQueries.s} {
    display: none;
  }
`;

const DesktopCall = styled.div`
  display: none;

  ${({ theme }) => theme.mediaQueries.s} {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    text-align: right;
  }

  a {
    color: inherit;
    text-decoration: underline;
  }
`;

/**
 * The call center CTA at the top right of the results page: a "Call now!"
 * button below the `s` breakpoint (375px), and "Questions?" over the number
 * from `s` up. For embeds like RealPage's, which hide the site header and its number.
 */
export const ResultsPhoneCta = () => (
  <>
    <MobileCall data-testid="results-phone-cta-mobile">
      <CallRailPhone
        componentType={CallRailComponentType.BUTTON_V2}
        buttonSize="m"
        buttonVariant="muted"
        text="Call now!"
        icon={<Phone size={20} weight="regular" />}
        clickEventName={Events.CALL_BUTTON_MOBILE_RESULTS}
      />
    </MobileCall>
    <DesktopCall data-testid="results-phone-cta-desktop">
      <Text variant="xs">Questions?</Text>
      <CallRailPhone
        text="###"
        variant="xsBold"
        clickEventName={Events.CALL_BUTTON_DESKTOP_RESULTS}
      />
    </DesktopCall>
  </>
);
